import React, { Suspense } from 'react';
import { loadFederatedModule } from '../../utils/loadFederatedModule';

// Import the federated ADO modal
const AdoModal = React.lazy(() => loadFederatedModule<typeof import('WF/AdoModal')>('WF/AdoModal'));

interface FederatedAdoModalProps {
  open: boolean;
  objectId: string;
  relationshipId?: string;
  onSave: (data?: unknown) => void;
  onClose: () => void;
  objectType: string;
}

export function FederatedAdoModal(props: FederatedAdoModalProps) {
  const { open, objectId, relationshipId, onSave, onClose, objectType } = props;

  // ADO modal is always enabled
  // Feature flag is used for type safety but the value is enforced to true
  if (!window.wbConfig.isEnhancedADOKrrUIEnabled) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <AdoModal open={open} objectId={objectId} relationshipId={relationshipId} onSave={onSave} onClose={onClose} objectType={objectType} />
    </Suspense>
  );
}
